import React from 'react'
import { AiFillDelete } from 'react-icons/ai'
import { useSelector,useDispatch } from "react-redux";



// const img1 =
//     "https://www.reliancedigital.in/medias/Apple-MGN63HNA-Laptops-491946461-i-1-1200Wx1200H?context=bWFzdGVyfGltYWdlc3wxNzczNDJ8aW1hZ2UvanBlZ3xpbWFnZXMvaDVhL2gyZC85NDQzMDgzNTgzNTE4LmpwZ3xhYzRiNWIxZGQ2NjNiNWIyYjI0Y2ZkYTZlZWQ3MTFjZTMxYzVmNDBiNmM5Mzk5OTM2OGVkZmExMjMyYjIxNDQ4";



const Cart = () => {
    const {cartItems=[] , subtotal, shipping,tax,total } = useSelector(state=>state.cart);
    const dispatch=useDispatch();

const increment=(id)=>{
    dispatch({
        type:'addToCart',
        payload:{ id },
    });
    dispatch({ type:'calculateprice'});
};
const decrement=(id)=>{
    dispatch({
        type:'decrement',
        payload: id ,
    });
    dispatch({ type:'calculateprice'});
};
const deletehandler=(id)=>{
    dispatch({
        type:'deleteFromCart',
        payload: id ,
    });
    dispatch({ type:'calculateprice'});
};
  return (
    <div className='cart'>
        <main>
        {cartItems.length> 0 ? (
        cartItems.map((i)=>(
            <CartItem
            imgSrc={i.imgSrc}
            name={i.name}
            price={i.price}
            qty={i.quantity}
            id={i.id}
            key={i.id}
            decrement={decrement}
            increment={increment}
            deletehandler={deletehandler}
            />
         ))
      ):(
          <h1>no items found...</h1>
      )}
        </main>
        <aside>
            <h2>subtotal: ${subtotal}</h2>
            <h2>shipping: ${shipping}</h2>
            <h2>tax: ${tax}</h2>
            <h2>total: ${total}</h2>
        </aside>
    </div>
  );
};
const CartItem=({
    imgSrc,
    name,
    price,
    qty,
    decrement,
    increment,
    deletehandler,
    id,
})=>(
    <div className="cartItem">
        <img src={imgSrc} alt="Items" />
        <article>
            <h3>{name}</h3>
            <p>${price}</p>
        </article>
        <div>
            <button onClick={()=>decrement(id)}>-</button>
            <p>{qty}</p>
            <button onClick={()=>increment(id)}>+</button>
        </div>

        <AiFillDelete onClick={()=>deletehandler(id)}/>
    </div>
);

export default Cart;
